import React, { useEffect, useState } from "react";
import { Nav } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import authMenu from "../../data/authMenu.json";
import userMenu from "../../data/userMenu.json";
import adminMenu from "../../data/adminMenu.json";
import { useTranslation } from "react-i18next";

const PersonalSidebar = () => {
  const { t } = useTranslation("admin");
  const [menus, setMenus] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));
  const location = useLocation();

  useEffect(() => {
    const isAdminRoute = location.pathname.includes('admin');
    if (isAdminRoute) {
      setMenus(adminMenu);
    } else {
      if (user && user.role === "admin") {
        setMenus(authMenu);
      } else {
        setMenus(userMenu);
      }
    }
  }, [location.pathname, user]);

  return (
    // 添加 d-flex 和 flex-column 确保 flex 布局
    // height: "100vh" 确保父容器撑开到全屏高度
    <Nav className="flex-column d-flex" style={{ height: "100vh", paddingBottom: '30px' }}>
      
      {/* 顶部 Logo 和 菜单区域 */}
      <div className="flex-grow-1"> 
        <div className="my-4 mt-0">
          <Nav.Link as={Link} to="/" target="_blank" className="text-center">
            <img
              src={`/img/logo.png`}
              alt="Logo"
              style={{
                width: "150px",
                filter: "grayscale(200%) brightness(700%)",
              }}
            />
          </Nav.Link>
        </div>

        {/* 动态渲染导航项 */}
        {menus.map(item => {
          const isActive = location.pathname === item.path;
          return (
            <React.Fragment key={item.path}>
              {item.active && <hr className="admin-divider my-2" />}
              <Nav.Link
                as={Link}
                to={item.path}
                active={isActive}
                className={isActive ? "sidebar-active" : ""}
              >
                {t(item.name)}
                {item.path === "/personal/split" && (
                  <span style={{ marginLeft: "4px" }}>
                    <img src="/img/sanger-crop-light.svg" 
                    className="sidebar-img-sanger-edit" 
                    />
                  </span>
                )}
              </Nav.Link>
            </React.Fragment>
          );
        })}
      </div>

      {/* 备案号部分 - 关键修改点 */}
      <div className="mt-auto text-center">
        <a
          href="https://beian.miit.gov.cn/#/Integrated/index"
          target="_blank"
          rel="noreferrer"
          className="beian-link-white"
        >
          浙ICP备2023007324号
        </a>
      </div>
    </Nav>
  );
};

export default PersonalSidebar;
